<template>
  <div class="partners">
    <div class="hero"></div>
    <div class="why-partners py-20 my-10">
      <FormattedHeader header="Why Partner with Bambee?" class="mb-16" />
      <div class="flex justify-center flex-wrap">
        <WhyBambeeInfoCard
          v-for="(reason, index) in reasonsToPartner"
          :key="`info-card-${index}`"
          v-bind="reason"
        />
      </div>
    </div>
    <div class="how-does-it-work">
      <TextImageBlock
        v-for="(banner, index) in banners"
        :key="`banners-${index}`"
        v-bind="banner"
        :index="index"
      >
      </TextImageBlock>
    </div>
  </div>
</template>

<script>
// DEPRECATED
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import WhyBambeeInfoCard from '@/modules/InformationPages/Partners/components/WhyBambeeInfoCard';
import TextImageBlock from '@/modules/InformationPages/Partners/components/TextImageBlock';
import FormattedHeader from '@/components/FormattedHeader';

import useGlobalSettings from '@/hooks/useGlobalSettings';

const reasonsToPartner = [
  {
    title: 'HR peace of mind for clients',
    body: 'Help your clients solve HR business challenges and take control of policies & procedures.',
    image: '/assets/information/partners/support-lady.svg',
  },
  {
    title: 'Earn commission on referrals',
    body: 'Refer clients to Bambee and earn commission from leads generated through your link.',
    image: '/assets/information/partners/laptop-platform.svg',
  },
  {
    title: 'Access to marketing materials',
    body: 'Gain access to marketing collateral, industry specific pages, and one-sheeters to help your clients understand Bambee.',
    image: '/assets/information/partners/bee.svg',
  },
];
const banners = [
  {
    id: 1,
    header: 'How does it work?',
    title: 'Refer clients to Bambee.com',
    body: `
    <ol>
      <li>1) Refer clients that are interested in HR services by using the unique link found in your partner dashboard.</li>
      <li>2) Earn commission once your client becomes a lead for Bambee.</li>
      <li>3) Partners will be paid out at the end of every month. You can find commission rates in your partner dashboard.</li>
    </ol>
    `,
    image: '/assets/information/partners/partner1.png',
  },
  {
    id: 2,
    header: 'Who is a good fit?',
    body: "The Bambee Partner Program will be a great fit if you work with small business owners. Whether you're an insurance broker, an insurance agent, or a payroll service provider, it's likely your client has questions about HR. We're here to address that challenge so they can focus on running their businesses.",
    image: '/assets/information/partners/partner2.png',
  },
  {
    id: 3,
    header: 'Are you ready to become a partner?',
    body: `
      <span>Sign up for Bambee's partner program today. We'll review your application and get you started as soon as possible.</span>
    `,
    image: '/assets/information/partners/partner3.png',
  },
];

export default defineComponent({
  name: 'PartnersRoot',
  components: {
    FormattedHeader,
    TextImageBlock,
    WhyBambeeInfoCard,
  },
  setup() {
    const { setHeader } = useGlobalSettings();

    setHeader({
      header: `Hire an HR Manager for $99/month`,
      subheader:
        'Partner with Bambee and help your clients get HR peace of mind.',
      heroImage: `../assets/information/partners/hero.jpg`,
      metaTitle: `Partner with Bambee!`,
      registration: false,
      noHero: false,
      noOverlay: true,
    });

    useMeta(() => ({ title: `Partner with Bambee!` }));

    return {
      reasonsToPartner,
      banners,
    };
  },
  head() {},
});
</script>
